// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__B8uXF","col":"CardReaderDesc_col__1VhAN","label":"CardReaderDesc_label__GWRy0"};